module.exports = __webpack_public_path__ + "images/b2a2e4a3c1ce88efca82bd1b7d4ae6af.png";